import { api } from "shared/config/api/api";
import type {
  TelegramLinkStartResponse,
  TelegramLinkStatusResponse,
  TelegramUnlinkResponse,
  WhatsappPhoneRequest,
  WhatsappPhoneResponse,
} from "../model/types";

export const twoFactorAuthApi = api.injectEndpoints({
  endpoints: (builder) => ({
    startTelegramLink: builder.mutation<TelegramLinkStartResponse, void>({
      query: () => ({
        url: "/users/2fa/telegram/link/start",
        method: "POST",
      }),
    }),
    getTelegramLinkStatus: builder.query<TelegramLinkStatusResponse, string>({
      query: (token) => ({
        url: "/users/2fa/telegram/link/status",
        params: { token },
      }),
      async onQueryStarted(_token, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.status === "confirmed") {
            dispatch(api.util.invalidateTags(["UserProfile"]));
          }
        } catch {
          // network/poll errors are surfaced via the query's own error state
        }
      },
    }),
    unlinkTelegram: builder.mutation<TelegramUnlinkResponse, void>({
      query: () => ({
        url: "/users/2fa/telegram/unlink",
        method: "POST",
      }),
      invalidatesTags: ["UserProfile"],
    }),
    submitWhatsappPhone: builder.mutation<
      WhatsappPhoneResponse,
      WhatsappPhoneRequest
    >({
      query: (body) => ({
        url: "/users/2fa/whatsapp/phone",
        method: "POST",
        body,
      }),
      invalidatesTags: ["UserProfile"],
    }),
  }),
});

export const {
  useStartTelegramLinkMutation,
  useGetTelegramLinkStatusQuery,
  useUnlinkTelegramMutation,
  useSubmitWhatsappPhoneMutation,
} = twoFactorAuthApi;
